/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";

import { useHistory } from "react-router-dom";

import { DeveloperCompanyModel } from "../../../../../domain/models/developer-company.model";

import InvoiceForm from "../../../../../presentation/pages/developer/foreign-note/form";

import toastUtils from "../../../../../utils/ToastUtils";
import { getErrorMessage } from "../../../../../presentation/helpers";

import { makeRemoteDeveloperCompanies } from "../../../usecases/developer-companies/remote-developer-companies-factory";
import { makeRemoteFiscalNote } from "../../../usecases/fiscal-note/remote-fiscal-note-factory";

const wrapPromotionType = (raw: any): { id: number } | undefined => {
  if (!raw) return undefined;
  const id = typeof raw === "object" ? raw.id : raw;
  if (!id) return undefined;
  return { id: Number(id) };
};

const MakeForeignNoteCreate: React.FC = () => {
  const [developerCompaniesList, setDeveloperCompaniesList] = React.useState<
    DeveloperCompanyModel[]
  >([]);

  const [submitting, setSubmitting] = React.useState<boolean>(false);

  const history = useHistory();

  React.useEffect(() => {
    (async () => {
      const econ = await makeRemoteDeveloperCompanies().getByDeveloper();
      setDeveloperCompaniesList(econ);
    })();
  }, []);

  const handleSubmit = async (
    values: any,
    setShowConfirm: any,
  ): Promise<void> => {
    setSubmitting(true);
    try {
      if (!values?.taker?.id) {
        toastUtils.showMessage({
          type: "warning",
          message: "Por favor, selecione um tomador!",
        });
        setSubmitting(false);
        return;
      }

      const parseCurrency = (val?: string): number =>
        Number(val?.replaceAll(".", "").replaceAll(",", ".")) || 0;

      const toSend: any = {
        developerCompany: {
          id: values?.company,
        },
        observation: values?.description,
        serviceList: [
          {
            conditionedDiscount: parseCurrency(values?.conditionedDiscount),
            cnae: { id: values?.cnae },
            nationalService: { id: values?.nationalService },
            nbs: { id: values?.nbs },
            issAliquot: Number(
              values.simplesNacional
                ? 0
                : values?.issAliquot?.replaceAll(".", "").replaceAll(",", "."),
            ),
            issRetained: values?.iss === "true",
            otherDeductions: parseCurrency(values?.otherDeductions),
            serviceValue: parseCurrency(values?.serviceValue),
            unconditionalDiscount: parseCurrency(values?.unconditionalDiscount),
            enforceability: values?.enforceability
              ? Number(values.enforceability)
              : undefined,
          },
        ],
        taker: { id: values?.taker?.id },
        competencia: values?.competencia,
        emissionDate: values?.emissionDate,
        hasRecurrence: false,
        hasNationalFiscal: true,
        hasForeignService: true,
        serviceProvisionMode: values?.serviceProvisionMode,
        serviceProvisionLink: values?.serviceProvisionLink,
        goodsMovementType: values?.goodsMovementType,
        mdicType: values?.mdicType,
        currencyType: values?.currencyType,
        foreignServiceValue: parseCurrency(values?.foreignServiceValue),
        providerPromotionType: wrapPromotionType(values?.providerPromotionType),
        clientPromotionType: wrapPromotionType(values?.clientPromotionType),
      };

      await makeRemoteFiscalNote().create(toSend);
      setShowConfirm(true);
      setTimeout(() => {
        setShowConfirm(false);
        history.push("/exterior");
      }, 6000);
      toastUtils.showMessage({
        type: "success",
        message: "Gerando com Sucesso!",
      });
    } catch (error: any) {
      const errorMessage = getErrorMessage(error);
      toastUtils.showMessage({
        type: "error",
        message: errorMessage,
      });
    }
    setSubmitting(false);
  };

  return (
    <InvoiceForm
      loading={false}
      handleSubmit={handleSubmit}
      developerCompaniesList={developerCompaniesList}
      submitting={submitting}
    />
  );
};

export default MakeForeignNoteCreate;
